<template>
  <v-layout row wrap class="textfield-landscape">
    <p> {{ data.config.question }}</p>
    <v-flex xs4>
      <v-text-field
        :value="data.value"
        @change="$emit('change', $event)"
        hide-details
        :suffix="getSuffixForSize (data.config)"></v-text-field>
    </v-flex>
  </v-layout>
</template>
<script>
  export default {
    name: 'TextfieldLandscape',
    props: {
      data: {
        required: true,
        type: Object
      }
    },
    methods: {
      getSuffixForSize(config) {
        if (config.field == 'size') {
          return config.options[Object.keys(config.options)[0]]
        } else {
          return ''
        }
      }
    }
  }

</script>
<style scoped>
  p {
    color: #616161;
    display: inline-block;
    float: left;
    margin-right: 20px;
    margin-top: 8px;
  }

  .v-input {
    font-size: 20px;
    margin-top: 0;
    padding-top: 0;
  }

</style>
